module.exports = __webpack_public_path__ + "static/media/left.e4a7676b.svg";